import { render, staticRenderFns } from "./IconSound.vue?vue&type=template&id=28aac176&"
import script from "./IconSound.vue?vue&type=script&lang=js&"
export * from "./IconSound.vue?vue&type=script&lang=js&"
import style0 from "./IconSound.vue?vue&type=style&index=0&id=28aac176&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports